module.exports = __webpack_public_path__ + "img/bio.148aec01.png";